/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:59:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-28 16:20:44
 */
import req from "@/utils/request";

//  微信列表查询
export const selectListPage = (params) => req.post("/interact-service/m/isApplyOpen/findListPage", params);

//  组织架构树
export const organTree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const save = (params) => req.post("/interact-service/m/isApplyOpen/save", params);
export const siteOne = (params) => req.post("/interact-service/m/isSiteOrganization/siteId", params);
export const deilsData = (params) => req.post("/interact-service/m/isApplyOpen/id", params);
export const findListLog = (params) => req.post("/interact-service/m/isApplyOpenLog/findListLog", params);
export const handle = (params) => req.post("/interact-service/m/isApplyOpenLog/handle", params);
export const careOf = (params) => req.post("/interact-service/m/isApplyOpenLog/careOf", params);
export const deleteRow = (params) => req.post("/interact-service/m/isApplyOpen/delete", params);
export const applyOpenOrganList = (params) => req.post("/manager-service/m/management/list", params);
export const findSmsManagementList = (params) => req.post("/manager-service/m/isCollectOperateLog/findSmsManagementList", params);
export const saveManagement = (params) => req.post("/manager-service/m/isApplyOpenSmsConfig/saveManagement", params);
export const selectListData = (params) => req.post("/manager-service/m/isSiteOrganization/selectList", params);

